import React, { useMemo, useState } from 'react'

import clsx from 'clsx'

import { Visibility, VisibilityOff } from '@mui/icons-material'
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material'

import styles from './Input.module.css'

type InputProps = Omit<TextFieldProps, 'onChange'> & {
  className?: string
  showPasswordIcon?: boolean
  readOnly?: boolean
  onChange?: (text: string, event: React.ChangeEvent<HTMLInputElement>) => void
}

const Input: React.FC<InputProps> = ({ InputProps, onChange, ...props }) => {
  const { className, showPasswordIcon, readOnly, ...otherProps } = props

  const [showPassword, setShowPassword] = useState(false)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (readOnly) return

    onChange?.(event.target.value, event)
  }

  const innerProps = useMemo(() => {
    if (showPasswordIcon) {
      return {
        type: showPassword ? 'text' : 'password',
        InputProps: {
          ...InputProps,
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton onClick={() => setShowPassword(!showPassword)} edge='end'>
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          )
        }
      }
    }

    return { InputProps }
  }, [showPassword, showPasswordIcon, InputProps])

  return (
    <TextField
      {...otherProps}
      className={clsx(className, showPasswordIcon && styles.passwordIcon)}
      onChange={handleChange}
      {...innerProps}
    />
  )
}

export default Input
